const CLOUD_FUNCTION_URL = 'https://us-central1-deluxe-software.cloudfunctions.net/enviarEmailClinica';

async function enviarEmail({ para, asunto, cuerpo, nombreClinica }) {
  const res = await fetch(CLOUD_FUNCTION_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ para, asunto, cuerpo, nombreClinica }),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.error || 'Error al enviar email');
  }
  return res.json();
}

export async function enviarRecordatorioTurno(paciente, clinicaData) {
  const { nombre, email, fecha, hora, medico, tipo, indicacionesPre } = paciente;
  if (!email) throw new Error('El paciente no tiene email registrado');

  const nombreClinica = clinicaData?.nombre || 'Su clínica';
  const direccion = clinicaData?.direccion ? `${clinicaData.direccion}, ${clinicaData.ciudad || ''}` : '';
  const tiposLabel = { consulta: 'Consulta', control: 'Control', estudio: 'Estudio diagnóstico', cirugia: 'Cirugía' };

  await enviarEmail({
    para: email,
    asunto: `Recordatorio de turno — ${nombreClinica}`,
    nombreClinica,
    cuerpo: `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; color: #1a1a1a;">
        <div style="background: #223A5E; padding: 24px; text-align: center;">
          <h2 style="color: #FFFFFF; margin: 0; font-size: 20px;">${nombreClinica}</h2>
          ${direccion ? `<p style="color: #8A9BB5; margin: 4px 0 0; font-size: 12px;">${direccion}</p>` : ''}
        </div>
        <div style="padding: 32px 24px; background: #F4F7FB;">
          <h2 style="color: #223A5E; margin: 0 0 16px;">Recordatorio de turno</h2>
          <p style="margin: 0 0 24px;">Hola <strong>${nombre}</strong>, te recordamos tu próximo turno:</p>
          <div style="background: #FFFFFF; border-radius: 8px; padding: 20px; margin-bottom: 24px; border-left: 4px solid #223A5E;">
            <p style="margin: 0 0 8px;"><strong>Fecha:</strong> ${fecha}</p>
            <p style="margin: 0 0 8px;"><strong>Hora:</strong> ${hora}</p>
            <p style="margin: 0 0 8px;"><strong>Médico:</strong> ${medico}</p>
            <p style="margin: 0;"><strong>Tipo:</strong> ${tiposLabel[tipo] || tipo}</p>
          </div>
          ${indicacionesPre ? `<div style="background: #E6F1FB; border-radius: 8px; padding: 16px; margin-bottom: 24px;"><p style="margin: 0 0 8px; font-weight: bold; color: #223A5E;">Indicaciones previas al turno:</p><p style="margin: 0; white-space: pre-wrap;">${indicacionesPre}</p></div>` : ''}
          <p style="color: #8A9BB5; font-size: 13px;">Ante cualquier consulta comunicate con nosotros.</p>
        </div>
        <div style="background: #223A5E; padding: 16px; text-align: center;">
          <p style="color: #8A9BB5; margin: 0; font-size: 11px;">${nombreClinica}${direccion ? ` · ${direccion}` : ''}</p>
          <p style="color: #8A9BB5; margin: 4px 0 0; font-size: 11px;">Enviado por Deluxe Software</p>
        </div>
      </div>
    `,
  });
}

export async function enviarLinkPortal(paciente, tokenPortal, clinicaData) {
  const { nombre, email } = paciente;
  if (!email) throw new Error('El paciente no tiene email registrado');

  const nombreClinica = clinicaData?.nombre || 'Su clínica';
  const direccion = clinicaData?.direccion ? `${clinicaData.direccion}, ${clinicaData.ciudad || ''}` : '';
  const link = `${window.location.origin}/portal?token=${tokenPortal}`;

  await enviarEmail({
    para: email,
    asunto: `Tu portal de paciente — ${nombreClinica}`,
    nombreClinica,
    cuerpo: `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; color: #1a1a1a;">
        <div style="background: #223A5E; padding: 24px; text-align: center;">
          <h2 style="color: #FFFFFF; margin: 0; font-size: 20px;">${nombreClinica}</h2>
          ${direccion ? `<p style="color: #8A9BB5; margin: 4px 0 0; font-size: 12px;">${direccion}</p>` : ''}
        </div>
        <div style="padding: 32px 24px; background: #F4F7FB;">
          <h2 style="color: #223A5E; margin: 0 0 16px;">Tu portal de paciente</h2>
          <p style="margin: 0 0 24px;">Hola <strong>${nombre}</strong>, podés acceder a tu portal personal donde encontrarás tus turnos, indicaciones y recetas.</p>
          <div style="text-align: center; margin: 32px 0;">
            <a href="${link}" style="background: #223A5E; color: #FFFFFF; padding: 14px 32px; border-radius: 8px; text-decoration: none; font-weight: bold; font-size: 15px;">Acceder a mi portal</a>
          </div>
          <p style="color: #8A9BB5; font-size: 12px; text-align: center;">Este link es personal e intransferible.</p>
        </div>
        <div style="background: #223A5E; padding: 16px; text-align: center;">
          <p style="color: #8A9BB5; margin: 0; font-size: 11px;">${nombreClinica}${direccion ? ` · ${direccion}` : ''}</p>
          <p style="color: #8A9BB5; margin: 4px 0 0; font-size: 11px;">Enviado por Deluxe Software</p>
        </div>
      </div>
    `,
  });
}

export async function enviarPresupuesto(presupuesto, clinicaData) {
  const nombreClinica = clinicaData?.nombre || 'Su clínica';
  const direccion = clinicaData?.direccion ? `${clinicaData.direccion}, ${clinicaData.ciudad || ''}` : '';
  if (!presupuesto.pacienteEmail) throw new Error('El paciente no tiene email registrado');

  const conceptos = [
    presupuesto.incluirEstudios && 'Estudios diagnósticos',
    presupuesto.incluirTratamientos && 'Tratamientos',
    presupuesto.incluirCirugias && 'Cirugías',
  ].filter(Boolean).join(', ');

  await enviarEmail({
    para: presupuesto.pacienteEmail,
    asunto: `Presupuesto médico — ${presupuesto.pacienteNombre}`,
    nombreClinica,
    cuerpo: `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; color: #1a1a1a;">
        <div style="background: #223A5E; padding: 24px; text-align: center;">
          <h2 style="color: #FFFFFF; margin: 0; font-size: 20px;">${nombreClinica}</h2>
          ${direccion ? `<p style="color: #8A9BB5; margin: 4px 0 0; font-size: 12px;">${direccion}</p>` : ''}
        </div>
        <div style="padding: 32px 24px; background: #F4F7FB;">
          <h2 style="color: #223A5E; margin: 0 0 8px;">Presupuesto médico</h2>
          <p style="color: #5A6A85; margin: 0 0 24px;">Estimado/a ${presupuesto.pacienteNombre},</p>
          ${conceptos ? `<div style="background: #E8EEF8; padding: 12px 16px; border-radius: 8px; margin-bottom: 16px; color: #223A5E; font-weight: 600;">${conceptos}</div>` : ''}
          ${presupuesto.detalle ? `<div style="background: #FFFFFF; padding: 16px; border-radius: 8px; margin-bottom: 24px; line-height: 1.6;">${presupuesto.detalle}</div>` : ''}
          <table style="width: 100%; border-collapse: collapse; margin-bottom: 24px;">
            ${presupuesto.montoContadoARS ? `<tr><td style="padding: 8px 12px; color: #5A6A85; border-bottom: 1px solid #D0D8E8;">Contado ARS</td><td style="padding: 8px 12px; color: #00A86B; font-weight: 700; text-align: right; border-bottom: 1px solid #D0D8E8;">$${parseFloat(presupuesto.montoContadoARS).toLocaleString('es-AR')}</td></tr>` : ''}
            ${presupuesto.montoContadoUSD ? `<tr><td style="padding: 8px 12px; color: #5A6A85; border-bottom: 1px solid #D0D8E8;">Contado USD</td><td style="padding: 8px 12px; color: #0099DD; font-weight: 700; text-align: right; border-bottom: 1px solid #D0D8E8;">USD ${parseFloat(presupuesto.montoContadoUSD).toFixed(2)}</td></tr>` : ''}
            ${presupuesto.montoFinanciadoARS ? `<tr><td style="padding: 8px 12px; color: #5A6A85; border-bottom: 1px solid #D0D8E8;">Financiado ARS</td><td style="padding: 8px 12px; color: #E09000; font-weight: 700; text-align: right; border-bottom: 1px solid #D0D8E8;">$${parseFloat(presupuesto.montoFinanciadoARS).toLocaleString('es-AR')}</td></tr>` : ''}
            ${presupuesto.montoFinanciadoUSD ? `<tr><td style="padding: 8px 12px; color: #5A6A85;">Financiado USD</td><td style="padding: 8px 12px; color: #E09000; font-weight: 700; text-align: right;">USD ${parseFloat(presupuesto.montoFinanciadoUSD).toFixed(2)}</td></tr>` : ''}
          </table>
          ${presupuesto.detalleFinanciacion ? `<div style="background: #FFF8E1; padding: 12px 16px; border-radius: 8px; margin-bottom: 24px; color: #E09000; font-size: 13px;">${presupuesto.detalleFinanciacion}</div>` : ''}
          <p style="color: #5A6A85; font-size: 13px;">Ante cualquier consulta, no dude en contactarnos.</p>
        </div>
        <div style="background: #223A5E; padding: 16px; text-align: center;">
          <p style="color: #8A9BB5; margin: 0; font-size: 11px;">${nombreClinica}${direccion ? ` · ${direccion}` : ''}</p>
          <p style="color: #8A9BB5; margin: 4px 0 0; font-size: 11px;">Enviado por Deluxe Software</p>
        </div>
      </div>
    `,
  });
}

export async function enviarReceta(paciente, turno, medicoNombre, clinicaData) {
  const { nombre, email } = paciente;
  if (!email) throw new Error('El paciente no tiene email registrado');

  const nombreClinica = clinicaData?.nombre || 'Su clínica';
  const direccion = clinicaData?.direccion ? `${clinicaData.direccion}, ${clinicaData.ciudad || ''}` : '';

  await enviarEmail({
    para: email,
    asunto: `Receta médica — ${nombreClinica}`,
    nombreClinica,
    cuerpo: `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; color: #1a1a1a;">
        <div style="background: #223A5E; padding: 24px; text-align: center;">
          <h2 style="color: #FFFFFF; margin: 0; font-size: 20px;">${nombreClinica}</h2>
          ${direccion ? `<p style="color: #8A9BB5; margin: 4px 0 0; font-size: 12px;">${direccion}</p>` : ''}
        </div>
        <div style="padding: 32px 24px; background: #F4F7FB;">
          <h2 style="color: #223A5E; margin: 0 0 16px;">Receta médica</h2>
          <p style="margin: 0 0 8px;"><strong>Paciente:</strong> ${nombre}</p>
          <p style="margin: 0 0 8px;"><strong>Médico:</strong> ${medicoNombre}</p>
          <p style="margin: 0 0 24px;"><strong>Fecha:</strong> ${new Date().toLocaleDateString('es-AR')}</p>
          <div style="background: #FFFFFF; border-radius: 8px; padding: 20px; border: 1px solid #D0D8E8; white-space: pre-wrap; line-height: 1.6;">${turno.receta}</div>
        </div>
        <div style="background: #223A5E; padding: 16px; text-align: center;">
          <p style="color: #8A9BB5; margin: 0; font-size: 11px;">${nombreClinica}${direccion ? ` · ${direccion}` : ''}</p>
          <p style="color: #8A9BB5; margin: 4px 0 0; font-size: 11px;">Enviado por Deluxe Software</p>
        </div>
      </div>
    `,
  });
}